import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useFnol } from '../../../context';
import FnolCategoryItem from './FnolCategoryItem';

const FnolCategoryList = ({ onClick }) => {
    const { fnolCategories } = useFnol();

    return (
      <List>
        {fnolCategories
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((category) => (
            <FnolCategoryItem
              key={category.key}
              fnolCategory={category}
              onClick={onClick}
            />
        ))}
      </List>
    );
};

FnolCategoryList.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default FnolCategoryList;

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style: none;
  padding: 0;
`;
